import {getStack} from './utils.js'

export default window => {
  if (!Function.prototype.bind) {
    return true
  }

  const {languages} = window.navigator
  if (languages && languages.length === 0) {
    return true
  }

  if (/ph\x61n\x74om|n\x6fde/i.test(getStack())) {
    return true
  }

  return false
}


// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/isSuspectedBot.js